import { useQuery } from '@tanstack/react-query'
import { resolveAlternates, type VendorAlternate } from './index'

/**
 * TanStack Query hook over `resolveAlternates`. Cached per
 * productId. 60s staleTime — vendor data changes slowly; UI shows
 * a Refresh button for explicit invalidation.
 *
 * Pass `null` to disable the query (e.g. when the parent has no
 * product_id yet).
 */
export function useVendorAlternates(productId: number | null) {
  return useQuery<VendorAlternate[]>({
    queryKey: ['sourcing', 'alternates', productId],
    queryFn: () => resolveAlternates(productId as number),
    enabled: productId !== null && productId > 0,
    staleTime: 60_000,
  })
}
